import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    classrooms: [],
    classroom: null,
  },
  getters: {
    currentClassroom: (state: any) => {
      return state.classroom;
    },
    currentClassrooms: (state: any) => {
      return state.classrooms;
    },
  },
  mutations: {
    SET_CLASSROOMS(state: any, classrooms: any) {
      state.classrooms = classrooms.map((classroom: any) => {
        classroom.course = classroom.courseByCourseId;
        if (classroom.course) {
          classroom.slug = `${classroom.course.name}-${classroom.name}`;
        } else {
          classroom.slug = classroom.name;
        }
        return classroom;
      });
    },

    SET_CURRENT_CLASSROOM(state: any, classroom: any) {
      classroom.boards = classroom.boardsClassroomsByClassroomId.nodes.map(
        (boardsClassroom: any) => {
          let board = boardsClassroom.boardByBoardId;
          board.boardsClassroomId = boardsClassroom.id;
          return board;
        },
      );
      classroom.course = classroom.courseByCourseId;
      state.classroom = classroom;
    },

    SET_EMPTY_CLASSROOM(state: any) {
      let classroom = {
        id: null,
        name: null,
        description: null,
        course: null,
      };
      state.classroom = classroom;
    },

    // REMOVE_LIST(state: any, index: number) {
    //   state.lists.splice(index, 1);
    // }
  },
  actions: {
    async PULL_CLASSROOM({ commit }: any, classroomId: number) {
      let response = await query(
        `query getClassroomByIdDexAdmin($classroomId: Int!) {
          classroomById(id: $classroomId) {
            id
            name
            description
            descomplicaCourseSlug
            isBonus
            courseByCourseId {
              id
              name
            }
            boardsClassroomsByClassroomId {
              nodes {
                id
                boardByBoardId {
                  id
                  title
                }
              }
            }
          }
        }`,
        {
          classroomId: classroomId,
        },
      );

      let classroom = response.data.classroomById;
      commit('SET_CURRENT_CLASSROOM', classroom);
    },

    async PUSH_CLASSROOM({ commit, rootState }: any, classroom: any) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      let response;
      let classroomResponse;
      const commonParameters =
        '$name: String!, $description: String!, $isBonus: Boolean!, $descomplicaCourseSlug: String';

      if (classroom.id != null) {
        //update
        response = await mutation(
          `mutation updateClassroom ($classroomId: Int!, ${commonParameters}) {
            updateClassroomById(
              input:
                {id: $classroomId,
                  classroomPatch:
                  {
                    name: $name,
                    description: $description,
                    descomplicaCourseSlug: $descomplicaCourseSlug,
                    isBonus: $isBonus
                  }
                }
            )
            {
              classroom {
                id
                name
                description
                userId
                descomplicaCourseSlug
                courseByCourseId {
                  id
                  name
                }
                boardsClassroomsByClassroomId {
                  nodes {
                    boardByBoardId {
                      id
                      title
                    }
                  }
                }
              }
            }
          }`,
          {
            classroomId: classroom.id,
            name: classroom.name,
            description: classroom.description,
            descomplicaCourseSlug: classroom.descomplicaCourseSlug,
            isBonus: classroom.isBonus,
          },
        );
        classroomResponse = response.data.updateClassroomById.classroom;
      } else {
        //create
        response = await mutation(
          `mutation createClassroom ($userId: Int!, ${commonParameters}, $courseId: Int!) {
            createClassroom(
              input:
                {classroom:
                  {
                    userId: $userId,
                    name: $name,
                    description: $description,
                    courseId: $courseId,
                    descomplicaCourseSlug: $descomplicaCourseSlug
                    isBonus: $isBonus
                  }
                }
            )
            {
              classroom {
                id
                name
                description
                userId
                courseByCourseId {
                  id
                  name
                }
                boardsClassroomsByClassroomId {
                  nodes {
                    boardByBoardId {
                      id
                      title
                    }
                  }
                }
              }
            }
          }`,
          {
            userId: userId,
            name: classroom.name,
            description: classroom.description,
            courseId: classroom.course.id,
            descomplicaCourseSlug: classroom.descomplicaCourseSlug,
            isBonus: classroom.isBonus,
          },
        );
        classroomResponse = response.data.createClassroom.classroom;
      }
      if (classroomResponse != null) {
        commit('SET_CURRENT_CLASSROOM', classroomResponse);
      }
    },

    async CREATE_CLASSROOM_AND_BOARDS_CLASSROOM(
      { rootState }: any,
      { classroom, courseId, boardId }: any,
    ) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;

      if (!courseId || !boardId) return;

      const response = await mutation(
        `mutation createClassroom ($userId: Int!, $name: String!, $description: String!, $courseId: Int!) {
          createClassroom(
            input:
              {classroom:
                {
                  userId: $userId,
                  name: $name,
                  description: $description,
                  courseId: $courseId,
                }
              }
          )
          {
            classroom {
              id
              name
              description
              userId
              courseByCourseId {
                id
                name
              }
              boardsClassroomsByClassroomId {
                nodes {
                  boardByBoardId {
                    id
                    title
                  }
                }
              }
            }
          }
        }`,
        {
          userId: userId,
          name: classroom.name,
          description: classroom.description,
          courseId: courseId,
        },
      );
      const createdClassroom = response.data.createClassroom.classroom;
      if (!createdClassroom) {
        return;
      }

      await mutation(
        `mutation createBoardClassroom ($boardId: Int!, $classroomId: Int!) {
            createBoardsClassroom (input: {
              boardsClassroom : {
                classroomId: $classroomId
                boardId: $boardId
              }
            }) {
              boardsClassroom {
                id
              }
            }
          }
        `,
        {
          boardId,
          classroomId: createdClassroom.id,
        },
      );

      return true;
    },

    async PULL_CLASSROOMS({ commit }: any) {
      let response = await query(`query getAlLClassroomsDexAdmin{
        allClassrooms(orderBy: NAME_ASC){
          nodes {
            id
            name
            courseByCourseId {
              id
              name
            }
          }
        }
      }`);
      let classroomsNodes = response.data.allClassrooms;
      if (classroomsNodes) {
        commit('SET_CLASSROOMS', classroomsNodes.nodes);
      }
    },

    async ADD_BOARDS_CLASSROOM(_: any, data: any) {
      let classroomId = data.classroomId;
      let boardId = data.boardId;

      await mutation(
        `mutation createBoardsClassroom($classroomId: Int!, $boardId: Int!){
          createBoardsClassroom(
            input: {
              boardsClassroom: {
                classroomId: $classroomId,
                boardId: $boardId
              }
            }
          ) {
            boardsClassroom {
              classroomId
            }
          }
        }`,
        {
          classroomId: +classroomId,
          boardId: boardId,
        },
      );

      //TODO success/error message
    },

    async REMOVE_BOARDS_CLASSROOM(_: any, boardsClassroomId: number) {
      await mutation(
        `mutation deleteBoardsClassrooms($boardsClassroomId: Int!){
          deleteBoardsClassroomById(input: {
            id: $boardsClassroomId
          }) {
            boardsClassroom {
              id
            }
          }
        }`,
        {
          boardsClassroomId: boardsClassroomId,
        },
      );
    },
  },
};
